import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';
import store from '@/store';

// 查询验收项目列表
export const queryAppointmentPages: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setAppointmentPages', { ...state.appointmentPage, loading: true });
    const params = { ...payload, statuses: [4] };
    const res: IPageData = await $http.post('/v1/design/acceptance/workinglist', params);
    const { list: data, total, pageNum, pageSize } = res;
    commit('setAppointmentPages', { data, total, pageNum, pageSize });
  } catch (e) {
    commit('setAppointmentPages', { data: [], total: 0, pageNum: 0, pageSize: 0 });
  }
};

// 查询设计商组织下的用户列表
export const queryUserPages: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setUserPages', { ...state.userPage, loading: true });
    const res: IPageData = await $http.post('/v1/data/baseinfo/user/availablelist', payload);
    const { list: data, total, pageNum, pageSize } = res;
    commit('setUserPages', { data, total, pageNum, pageSize });
  } catch (e) {
    commit('setUserPages', { data: [], total: 0, pageNum: 0, pageSize: 0 });
  }
};

// 接受项目预约
export const acceptAppointment: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, loading: true });
    await $http.post('/v1/design/acceptance/acceptappointment', payload);
    store.commit('common/setToast', { visible: true, text: '确认成功' });
  } finally {
    commit('setDialog', { visible: false });
  }
};

// 拒绝项目预约
export const rejectAppointment: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, loading: true });
    const res = await $http.post('/v1/design/acceptance/reject', payload);
    store.commit('common/setToast', { visible: true, text: '已拒绝项目' });
  } finally {
    commit('setDialog', { visible: false });
  }
};

